import * as React from 'react';
import { RouterState } from 'connected-react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-light-svg-icons';

type EmbeddedViewProps = {
    router: RouterState;
}

interface EmbeddedViewState {
    url: string | null;
    isLoading: boolean;
}

class EmbeddedView extends React.Component<EmbeddedViewProps, EmbeddedViewState> {
    constructor(props: EmbeddedViewProps) {
        super(props);
        const url = new URLSearchParams(props.router.location.search).get('url');
        if (url) {
            this.state = {
                url: atob(url),
                isLoading: url ? true : false
            };
        }
    }

    private handleLoad = () => {
        this.setState({
            isLoading: false
        });
    }

    public render() {
        return (
            <>
                {this.state.isLoading && this.state.url && (
                    <section className="align-self-center text-center">
                        <p>Initiating Data Exchange...</p>
                        <FontAwesomeIcon icon={faSpinner} size="3x" spin={true} />
                    </section>
                )}
                {this.state.url &&
                    <iframe width="100%" height="100%" src={this.state.url} onLoad={this.handleLoad} />
                }
            </>
        );
    }
}

export default EmbeddedView;
